import {collection, component, EntityData, field, identifier} from "@fedeltapointofsale/data-client";
import {TaxReferenceData} from "../tax/tax.data";
import {AddressData} from "../../address/address.data";
import {UncachedImageData} from "../../shared/image/uncached-image.data";

export class TaxOnReceiptData extends EntityData<TaxOnReceiptData> {
    @component tax: TaxReferenceData;
    @field symbol: string;
}

export class ReceiptConfigurationData extends EntityData<ReceiptConfigurationData> {
    @identifier receiptConfigId: number;
    @field header: string;
    @field footer: string;
    @field printCompanyName: boolean;
    @field printTelephone: boolean;
    @field printStreet: boolean;
    @field printSuburb: boolean;
    @field printState: boolean;
    @field printPostcode: boolean;
    @field printBarcode: boolean;
    @field printAbn: boolean;
    @field printGstNumber: boolean;
    @field printFreeItems: boolean;
    @field itemiseExtras: boolean;
    @field printForeignName: boolean;
    @field printLargeOrderName: boolean;
    @field includeTaxesInPriceLines: boolean;
    @field userIdentifier: string = "None";

    @collection(TaxOnReceiptData) taxesOnReceipt: TaxOnReceiptData[];
}

export class CompanyDetailsData extends EntityData<CompanyDetailsData> {
    @identifier companyDetailsId: number;
    @field companyName: string;
    @field ABN: string;
    @field gstNumber: string;
    @field telephone: string;
    @field email: string;
    @field currency: string = "AUD";
    @component logoImageData: UncachedImageData;
    @component address: AddressData;
    @component receiptConfiguration: ReceiptConfigurationData;
}

export class CompanyDetailsReferenceData extends EntityData<CompanyDetailsReferenceData> {
    @identifier companyDetailsId: number;
    @field companyName: string;
}
